import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const PlusIcon = ({ color = 'currentColor', width = 24, height = 24, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12 3C12.6904 3 13.25 3.55964 13.25 4.25V10.75H19.75C20.4404 10.75 21 11.3096 21 12C21 12.6904 20.4404 13.25 19.75 13.25H13.25V19.75C13.25 20.4404 12.6904 21 12 21C11.3096 21 10.75 20.4404 10.75 19.75V13.25H4.25C3.55964 13.25 3 12.6904 3 12C3 11.3096 3.55964 10.75 4.25 10.75H10.75V4.25C10.75 3.55964 11.3096 3 12 3Z"
                fill={color}
            />
        </svg>
    );
};
